import script from "./VmStorageOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./VmStorageOptions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__